var React = require('react');
import { Box, Container, Grid } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import DeleteIcon from "@material-ui/icons/Delete";
import SearchIcon from "@material-ui/icons/Search";
import Button from "@mui/material/Button";
import SaveIcon from "@material-ui/icons/Save";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import {MuiThemeProvider } from '@material-ui/core/styles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import CloseIcon from '@mui/icons-material/Close';
import { muiThemeDesign } from '../../mui-theme-design';
import { makeStyles } from "@mui/styles";
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
//import ReportUserRoster from './ReportUserRoster';
import FormControl from '@mui/material/FormControl';
import { Stack,CircularProgress } from '@mui/material';
import Fade from '@mui/material/Fade';
import DataPivot from '../Table/DataPivot'
import {logger,checkAuthentication} from '../../utils';
import FormControlLabel from '@mui/material/FormControlLabel';


const pageStyles = makeStyles({
    container: {
        display: "flex",
        flexFlow: "column wrap",
        gap: "5px",
        height: "300px", // set the height limit to your liking
        overflow: "auto",
        //    width: "400px"
    },
    reports: {
        width: 120,
        display: "flex",
        textAlign: "left",
        paddingLeft: "10px",
        alignItems: "center"
    },
    root: {
        display: "flex",
 //       flexFlow: "column wrap",
        gap: "5px",
  //      height: "400px", 
        overflow: "auto",
        "& .MuiList-root": {      
            display: "flex",
            flexFlow: "row",
            flexWrap: "wrap",
            gap: "5px",
            height: "500px", // set the height limit to your liking
            overflow: "auto",
            width: "800px",
            height: "500px"
        },
        "& .MuiListItem-root": {
            width: 180,
            height: 30,
            color: "#772c97"
        },
        "& .MuiListItemText-root": {
        //    width: 180,
        //    height: 20,
            display: "flex",
            textAlign: "left",
            paddingLeft: "10px",
            alignItems: "center"
        },
        "& .MuiDialog-root": {           
            height: 500
        },
        "& .MuiDialogContent-root": {
           height: 500
        },
        "& .MuiPaper-root": {
            height: 80
        }

    },
    root2: {
        
        "& .MuiPaper-root": {
            height: 500,
            display: "flex",
        }
    }, 
    tools: {
        "& .MuiAppBar-root": {
            MaxHeight: "80px"
        }
    },
});

export default function ReportUserRosterConfig({ handleRosterCallback, propString }) {
    const [refresh, setRefresh] = React.useState(false);
    const [dataSet, setDataSet] = React.useState([]);
    const [open, setOpen] = React.useState(false);
    const classes = pageStyles();

    const [PropTypePick, setPropTypePick] = React.useState([]);
    const [PropTypeList, setPropTypeList] = React.useState([]);
    
    const [LockedAlert, setAlert] = React.useState(false);
    const [AlertText, setAlertText] = React.useState('');
    const [selectAllRosters, setSelectAllRosters] = React.useState(false);
    const [InactiveUsers, SetInactiveUsers] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(true);

    const setPropType = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.Name, value: choice.ID }))
        setPropTypeList(choices)
		setIsLoading(false);
    }
    
    const handleAlertClose = () => {
        setAlert(false);
    };
    
    const handlePropTypePick = (value) => () => {
        const currentIndex = PropTypePick.indexOf(value);
        const newChecked = [...PropTypePick];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }
        setPropTypePick(newChecked);

     //   logger("configPropPick ", PropTypePick)
    }; 

    const generateUserRoster = async () => {
       await fetch('api/Reports/UserRoster/${propString}', {
            method: 'Get',
        })                                        
            .then(res => res.json())
            .then(json => setPropType(json));
     ;
       //   logger(dataSet); 
    }   
    const options = {
        filter: true,
        filterType: 'dropdown',
        responsive: 'vertical',
        selectableRows: 'none',
     //   customToolbar: () => (<ReportUserRoster handleDialogCallback={handleDialogCallback} dataSet={propString } />)
    };

    const handlePivotCallback = (childData) => {
     //   logger(childData);
    };

    const handleClickOpen = () => {

        setRefresh(true)
        setOpen(true);
        setPropTypePick([])
        setSelectAllRosters(false);
    };

    const handleClose = () => {
        setPropTypePick([])
        setOpen(false);
    };

    const handleCloseConfig = () => {
        setOpen(false)
        
    };
    const initialValues = {

        selectedProperties: []
    };


    const validFormSchema = Yup.object({

    });

    const onTrigger = React.useCallback((values) => {
	if(PropTypePick.length>0){
	      //  logger("trigger")
	      //  logger('TriggerPropPick  ' + PropTypePick)
	        const propString = PropTypePick.map((p) => { return `user_prop_type.ID=${p}` }).join(" OR ");
	     //  logger("ConfigString   " + propString)
	      //  rosterData(propString)
	      //      .then(setPropTypePick([]))
	      //   logger('config ProcessedData' , dataSet));
	        setOpen(false);
        handleRosterCallback(propString, InactiveUsers)
	        handleClose;
       }else{
		   setAlertText("Please select an Employee Roster Property");
		   setAlert(true);
	   }
    });


    const rosterData = async (childData) => {
        await fetch(`api/Reports/UserRoster/${childData}`, {
            method: 'Get',
        })
            .then(res => res.json())
            .then(json => DataPivot(json).then(res => setDataSet(res)))
         //   .then(json => logger("I inside of fetch", DataPivot(json)))

        //  const report =  ReportUserRoster(dataSet)
        
        // setRefresh(false);

        setRefresh(true)
    };


    React.useEffect(() => {
		checkAuthentication();
        if (refresh) {
            fetch('api/UserPropType/dropdown')
                .then(res => res.json())
                .then(json => setPropType(json))
            //     logger(PropTypeList);

            /*          fetch('api/Reports/UserRoster/${propString}')
                         .then(res => res.json())
                         .then(json => setDataSet(json))
                     logger(dataSet);
                     */
            setRefresh(false);
        }
    });
    
	const selectAllRostersForReport = (select_all_rosters) => {
		setSelectAllRosters(select_all_rosters);
		logger("select_all_rosters", select_all_rosters);
		//setRefresh(true);

		var checkbox_list = document.getElementsByName('checkbox-list-item');
		const newChecked = [...PropTypePick];
		if (select_all_rosters) {
			for (var i = 0; i < checkbox_list.length; i++) {
				var val = checkbox_list[i].getAttribute('data-testid');
				if (newChecked.indexOf(parseInt(val)) === -1) {
					newChecked.push(parseInt(val));
				}
			}
			setPropTypePick(newChecked);
		} else {
			setPropTypePick([]);
		}
	};
    return (
       
        <Box>     <MuiThemeProvider theme={muiThemeDesign}>
                <Button variant="contained" onClick={handleClickOpen}>
                    Employee Rosters
                </Button>
            <Dialog open={open}
                    onClose={handleClose}
                     maxWidth="lg"
          //      fullScreen
            >
                <DialogContent className={classes.root }>
                    <Box>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validFormSchema}
                        onSubmit={(values, { resetForm }) => {
                            onTrigger(values);
                            resetForm();
                        }}
                    >
                        {props => (
                            <Form>
                                    <AppBar className={classes.tools} position="relative" >
                                        <Box sx={{ height: '80px' }}>
                                        <Toolbar>
                                            <IconButton
                                            edge="start"
                                            color="inherit"
                                            onClick={handleClose}
                                            aria-label="close"
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                        <Typography sx={{ ml: 2, flex: 1  }} variant="h6" component="div">
                                            Employee Rosters
                                        </Typography>
                                        <div>
                                                    <FormControlLabel
                                                        name="InactiveUsers"
                                                        label="Inactive Users"
                                                        style={{ color: 'white' }}
                                                        control={<Checkbox
                                                            checked={InactiveUsers}
                                                            labelStyle={{ color: 'white' }}
                                                            iconStyle={{ fill: 'white' }}
                                                            inputStyle={{ color: 'white' }}
                                                            style={{ color: 'white' }}
                                                            onChange={e => { SetInactiveUsers(!InactiveUsers) }} />}
                                                    />
                                                    <FormControlLabel
							                            name="selectAll"
							                            label="Select All"
							                            style={{ color: 'white' }}
							                            control={<Checkbox
							                                checked={selectAllRosters}
							                                labelStyle={{ color: 'white' }}
							                                iconStyle={{ fill: 'white' }}
							                                inputStyle={{ color: 'white' }}
							                                style={{ color: 'white' }}
							                                onChange={e => { selectAllRostersForReport(!selectAllRosters) }} />}
							                        />
                                                    <Button autoFocus color="inherit" onClick={props.handleSubmit}>
                                                        Generate Report
                                                    </Button>
                                                </div>


                                            </Toolbar>
                                         </Box>
                                </AppBar>
                                <DialogTitle>Select Report Data</DialogTitle> 
                                 {(isLoading) &&

                                        <FormControl sx={{ m: 1, height: 200, width: 300 }}>
                                          
                                                <Fade
                                                    in={(isLoading)}
                                                    style={{
                                                        transitionDelay: !isLoading ? '800ms' : '0ms',
                                                    }}
                                                    unmountOnExit
                                                >
                                                    <Stack sx={{ color: 'grey.500' }} spacing={2} direction="row" justifyContent="center">
                                                        <CircularProgress color="secondary" />
                                                        <CircularProgress color="success" />
                                                        <CircularProgress color="inherit" />
                                                    </Stack>
                                                </Fade>
                                           
                                        </FormControl>
                                    }
                                 {(!isLoading) &&
                                    <div sx={{ height: 400 }}>                                                                      
                                    	<List sx={{ bgcolor: "background.paper" }} >
                                        <div className={classes.root2} style={{ display: "flex", flexWrap:"wrap", flexFlow:"column-wrap" }}>
                                            {
                                                PropTypeList.map((value) => {
                                                    const labelId = `checkbox-list-${value.value}`;
                                                    return (
                                                        <ListItem key={value.value} disablePadding >   
                                                            < ListItemButton onClick={handlePropTypePick(value.value)} >
                                                                <ListItemIcon>
                                                                < Checkbox
                                                                	name="checkbox-list-item"
                                                                    edge="end"
                                                                    onChange={handlePropTypePick(value.value)}
                                                                    checked={PropTypePick.indexOf(value.value) !== -1}
                                                                    inputProps={{ 'aria-labelledby': labelId, 'data-testid': value.value }}
                                                                  />
                                                            <ListItemText id={labelId} primary={value.label} />
                                                            </ListItemIcon>
                                                            </ListItemButton>
                                                        </ListItem>
                                                    );
                                            })}
                                        </div>
                                     </List>
                                 </div>  
                                 }
                             </Form>
                            )}
                        </Formik>
                      </Box>
                </DialogContent>
                <Dialog
                    open={LockedAlert}
                    onClose={handleAlertClose}
                    aria-labelledby="L&P Lock"
                    aria-describedby="Time Period locked for this work"
                >
                    <DialogTitle id="Time Entry">
                        {"Alert"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {AlertText}
                        </DialogContentText>
                    </DialogContent>
                    
                    <DialogActions>
                        <Button onClick={() => { setAlert(false) }} autoFocus>Close</Button>
                    </DialogActions>
                </Dialog>
            </Dialog> 
        </MuiThemeProvider>
            </Box>
    );
}
